module.exports = __webpack_public_path__ + "8c645807798eeb2983749c1500e30c19.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/default-avatar.png
 ** module id = 180
 ** module chunks = 0
 **/